﻿import React, { type PropsWithChildren } from "react";
import { observer } from "mobx-react";
import { RichToolTipComponent } from "../rich-tooltip/RichToolTipComponent";

interface IStaticNotificationComponentProps {
    type?: NotificationType;
    title?: string;
    customClass?: string;
    hideIcon?: boolean;
    toolTip?: string;
    solid?: boolean;
}

@observer
export class StaticNotificationComponent extends React.Component<PropsWithChildren<IStaticNotificationComponentProps>> {
    render() {
        const { props } = this;
        const { type, title, customClass, hideIcon, toolTip, solid } = props;

        return (
            <div className={"notification " + type + (customClass === undefined ? "" : " " + customClass) + (solid === undefined ? "" : " solid")}>
                {title !== undefined && (
                    <div className={"title"}>
                        {!hideIcon && <div className={"icon-holder"}>&nbsp;</div>}
                        {title}
                        {toolTip !== undefined && (
                            <RichToolTipComponent toolTipContent={toolTip} className={"info-tooltip"}>
                                &nbsp;
                            </RichToolTipComponent>
                        )}
                    </div>
                )}
                {this.props.children && <div className={"content"}>{this.props.children}</div>}
            </div>
        );
    }
}

export type NotificationType = "" | "info" | "warning" | "error" | "success" | "step";
